/**webSocket */
let ws = {
    //检测浏览器是否支付ws链接
    able:(dz)=>{
        if ("WebSocket" in window) {
            return new WebSocket(dz);
        }else{
            alert("您的浏览器无法播放");
            return undefined;
        }
    },

}

export default ws;